import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SiLoadingSpinnerComponent } from '@siemens/element-ng/loading-spinner';

@Component({
  selector: 'app-insights',
  imports: [CommonModule, SiLoadingSpinnerComponent],
  templateUrl: './insights.component.html',
  styleUrl: './insights.component.scss',
})
export class InsightsComponent {
  @Input() finalResponse: string | undefined;
  @Input() isExecuting?: boolean = false;
  @Input() errorMessage?: string = '';
  @Input() isUserSubmitted?: boolean = false;
}
